function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaintRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.706 25.705C29.222 24.697 27 21.002 27 21.002s-2.222 3.695-2.706 4.703a3 3 0 105.412 0zM16 14.002a2 2 0 01-1.96-2.395l-3.265-3.263-.018.018-1.165-1.165a1.875 1.875 0 010-2.65c.73-.731 1.921-.731 2.633-.02l1.151 1.216-1.187 1.187 3.184 3.182a1.97 1.97 0 01.627-.11 2 2 0 010 4zm.1-10.982l-1.309 1.308-1.135-1.195a3.878 3.878 0 00-5.478 0 3.877 3.877 0 000 5.478l1.165 1.165-5.179 5.179a3.973 3.973 0 000 5.619l6.281 6.282a3.963 3.963 0 002.81 1.164 3.96 3.96 0 002.809-1.164L28 14.92 16.1 3.02z",
    fill: props.color
  }));
}

export default SvgIconPaintRexFilled;